export const rowClassName = (rowData) => {
  // [bg, text] — yellow/gray are light so they get dark text; all others get white
  const COLOR_MAP = {
    Pending: ["bg-blue-500", "text-gray-100"],
    Overstay: ["bg-yellow-500", "text-gray-900"],
    Claimed: ["bg-emerald-500", "text-gray-100"],
    Removed: ["bg-slate-500", "text-gray-100"],
    Cancelled: ["bg-slate-500", "text-gray-100"],
    "Take-Back": ["bg-orange-500", "text-gray-100"],
    "For RTS": ["bg-orange-500", "text-gray-100"],
    Revoked: ["bg-red-700", "text-gray-100"],
    "RTS Overstay": ["bg-red-500", "text-gray-100"],
    RTS: ["bg-red-700", "text-gray-100"],
    "Cleared Out": ["bg-purple-500", "text-gray-100"],
    New: ["bg-gray-300", "text-gray-900"],
    "Drop-Off": ["bg-sky-500", "text-gray-100"],
  };
  const [bg, text] = COLOR_MAP[rowData] ?? ["bg-gray-300", "text-gray-900"];
  return `${bg} ${text} font-normal text-center border-0`;
};
